import {
  SET_INVENTORY_FILTERS,
  SET_INVENTORY_DATE_RANGE,
  SET_INVENTORY_DATA,
  CLEAR_INVENTORY_STATE,
} from '../actions/inventoryActions';

interface InventoryState {
  filters: any[];
  dateRange: [string, string] | null;
  data: any;
  lastFetched: number | null;
}

const initialState: InventoryState = {
  filters: [],
  dateRange: null,
  data: {},
  lastFetched: null,
};

const inventoryReducer = (state: InventoryState | undefined, action: any): InventoryState => {
  if (!state) state = initialState;
  switch (action.type) {
    case SET_INVENTORY_FILTERS:
      return {
        ...state,
        filters: action.payload,
      };

    case SET_INVENTORY_DATE_RANGE:
      return {
        ...state,
        dateRange: action.payload,
      };

    case SET_INVENTORY_DATA:
      return {
        ...state,
        data: action.payload,
        lastFetched: Date.now(),
      };

    case CLEAR_INVENTORY_STATE:
      return initialState;

    default:
      return state;
  }
};

export default inventoryReducer;
